import React from 'react'
import { useIntl } from 'react-intl'

import DetailsBillingSection from './details-billing-section/DetailsBillingSection'
import { BillingColumns } from '../BillingColumns'
import { DescriptionMode } from '../DescriptionMode'
import { ClientPricingItemFragment } from '../../../../../../lib/graphql'
import { IconSvg } from '../../../../../atoms'

export interface ClientPricingItemSections {
  batchProvisionClientPricingItems: ClientPricingItemFragment[]
  houseClientPricingItems: ClientPricingItemFragment[]
  restaurationClientPricingItems: ClientPricingItemFragment[]
  activityClientPricingItems: ClientPricingItemFragment[]
  mobilityClientPricingItems: ClientPricingItemFragment[]
}

interface IDetailsClientPricingItemSectionsProps {
  clientPricingItemSections: ClientPricingItemSections
}

const DetailsClientPricingItemSections = ({
  clientPricingItemSections: {
    batchProvisionClientPricingItems,
    houseClientPricingItems,
    restaurationClientPricingItems,
    activityClientPricingItems,
    mobilityClientPricingItems,
  },
}: IDetailsClientPricingItemSectionsProps) => {
  const intl = useIntl()
  return (
    <div className='flex flex-col gap-3'>
      {batchProvisionClientPricingItems.length > 0 && (
        <DetailsBillingSection
          clientPricingItems={batchProvisionClientPricingItems}
          title={{
            label: intl.formatMessage({
              id: 'ui.DetailsClientPricingItemSections.batchProvisionsTitle',
              defaultMessage: 'Forfaits',
            }),
            icon: (
              <IconSvg.House
                style={{ height: 13, width: 13, marginRight: 7 }}
              />
            ),
          }}
          columns={[
            BillingColumns.description,
            BillingColumns.unit,
            BillingColumns.unitHT,
            BillingColumns.vatRate,
            BillingColumns.ownerFeesRate,
            BillingColumns.unitTTC,
          ]}
          descriptionMode={DescriptionMode.toggable}
        />
      )}
      {houseClientPricingItems.length > 0 && (
        <DetailsBillingSection
          clientPricingItems={houseClientPricingItems}
          title={{
            label: intl.formatMessage({
              id: 'ui.DetailsClientPricingItemSections.houseTitle',
              defaultMessage: 'Logement',
            }),
            icon: (
              <IconSvg.House
                style={{ height: 13, width: 13, marginRight: 7 }}
              />
            ),
          }}
          columns={[
            BillingColumns.description,
            BillingColumns.unit,
            BillingColumns.unitHT,
            BillingColumns.vatRate,
            BillingColumns.ownerFeesRate,
            BillingColumns.unitTTC,
          ]}
          descriptionMode={DescriptionMode.toggable}
        />
      )}
      {restaurationClientPricingItems.length > 0 && (
        <DetailsBillingSection
          clientPricingItems={restaurationClientPricingItems}
          title={{
            label: intl.formatMessage({
              id: 'ui.DetailsClientPricingItemSections.restorationTitle',
              defaultMessage: 'Restauration',
            }),
            icon: (
              <IconSvg.Restauration
                style={{ height: 13, width: 13, marginRight: 7 }}
              />
            ),
          }}
          columns={[
            BillingColumns.description,
            BillingColumns.unit,
            BillingColumns.unitHT,
            BillingColumns.vatRate,
            BillingColumns.ownerFeesRate,
            BillingColumns.unitTTC,
          ]}
          descriptionMode={DescriptionMode.toggable}
        />
      )}
      {activityClientPricingItems.length > 0 && (
        <DetailsBillingSection
          clientPricingItems={activityClientPricingItems}
          title={{
            label: intl.formatMessage({
              id: 'ui.DetailsClientPricingItemSections.activitiesTitle',
              defaultMessage: 'Activités',
            }),
            icon: (
              <IconSvg.Racket
                style={{ height: 13, width: 13, marginRight: 7 }}
              />
            ),
          }}
          columns={[
            BillingColumns.description,
            BillingColumns.unit,
            BillingColumns.unitHT,
            BillingColumns.vatRate,
            BillingColumns.ownerFeesRate,
            BillingColumns.unitTTC,
          ]}
          descriptionMode={DescriptionMode.toggable}
        />
      )}
      {mobilityClientPricingItems.length > 0 && (
        <DetailsBillingSection
          clientPricingItems={mobilityClientPricingItems}
          title={{
            label: intl.formatMessage({
              id: 'ui.DetailsClientPricingItemSections.transportTitle',
              defaultMessage: 'Transport',
            }),
            icon: (
              <IconSvg.Train
                style={{ height: 13, width: 13, marginRight: 7 }}
              />
            ),
          }}
          columns={[
            BillingColumns.description,
            BillingColumns.unit,
            BillingColumns.unitHT,
            BillingColumns.vatRate,
            BillingColumns.ownerFeesRate,
            BillingColumns.unitTTC,
          ]}
          descriptionMode={DescriptionMode.toggable}
        />
      )}
    </div>
  )
}

export default DetailsClientPricingItemSections
